import {
  activeFeedbackTabSelector,
  feedbacksSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { adjustFeedbacksInRedux } from '@chegg-wt/core-wa/components/CardsContainer/SuggestionTabs/utils'
import { deleteFeedback } from '@chegg-wt/core-wa/state/actions'
import { FeedbackType } from '@chegg-wt/core-wa/types'
import { HistoryDeltaAction, RedoFeedbackDeltaParams } from '../types'
import getFeatureEditor from '../../getEditor'
import { getFeedbackPosition } from '../../helpers'
import {
  getFeedbackKeyFromPosition,
  getKeyFromSentence,
  isSameTabOpen,
  openSameTab,
  selectNextCard,
} from './commonUtils'

export const redoFeedbackDelta = ({
  feedbackDelta,
  dispatch,
  state,
  removedGrammarCards,
  removedParaphraseCards,
}: RedoFeedbackDeltaParams) => {
  const editor = getFeatureEditor()
  feedbackDelta.forEach((delta) => {
    const { feedback, action } = delta
    editor.commands.clearAllHighlights()
    const activeFeedbackTab = activeFeedbackTabSelector(state)
    const sentenceOffsets = sentenceOffsetsSelector(state)
    if (
      action === HistoryDeltaAction.APPLY &&
      feedback.feedbackType === FeedbackType.GRAMMAR
    ) {
      // We need to adjust grammar offsets in this case
      const feedbacks = feedbacksSelector(state)
      const appliedFeedback = {
        ...feedback,
        impactedText: ' '.repeat(feedback.position.length), // Only length is used in adjustFeedbacksInRedux, text not matter
      }
      adjustFeedbacksInRedux(feedbacks, appliedFeedback, dispatch)
    }
    dispatch(deleteFeedback(feedback.id))
    if (isSameTabOpen(feedback.feedbackType, activeFeedbackTab)) {
      // Remove underline if we are on same tab
      const feedbackPosition = getFeedbackPosition(feedback, sentenceOffsets)
      editor.commands.removeCustomUnderline({
        id: feedback.id,
        offset: feedbackPosition.offset,
        length: feedbackPosition.length,
      })
    }
    openSameTab(feedback.feedbackType, activeFeedbackTab, dispatch)
    const feedbacks = feedbacksSelector(state)
    selectNextCard(feedbacks, feedback, dispatch)

    if (action === HistoryDeltaAction.DISCARD) {
      // Special case to handle discard
      const sentence = sentenceOffsets.find(
        (sentence) => sentence.id === feedback.sentenceId
      )
      const key = getKeyFromSentence(feedback.sentenceId, sentence.originalText)
      if (feedback.feedbackType === FeedbackType.GRAMMAR) {
        if (!removedGrammarCards.get(key)) {
          removedGrammarCards.set(key, new Set<string>())
        }
        const { position } = feedback
        removedGrammarCards.get(key).add(getFeedbackKeyFromPosition(position))
      } else removedParaphraseCards.set(key, true)
    }
  })
}
